export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-04.22402e50.jpg";